import { Component } from "react";
import "../styles/channel_how_it_works.css";

class ChannelHowItWorks extends Component {
  render() {
    return (
      <section id="how-it-works" className="py-5 bg-white">
        <div className="container py-lg-5">
          <div className="text-center mb-5 pb-lg-4">
            <h2 className="display-5 fw-medium how-it-works-header">
              How it Works
            </h2>
          </div>

          {/* ==========================================
              DESKTOP LAYOUT
              ========================================== */}
          <div className="row g-5 d-none d-lg-flex">
            {/* Column 1 */}
            <div className="col-lg-4 d-flex flex-column gap-5">
              <div className="step-content">
                <div className="step-circle shadow-sm">1</div>
                <h3 className="step-title">Discover the Power of XLP Pulse</h3>
                <p className="step-text">
                  Interested in <strong>XLP Pulse</strong>? Reach out to learn
                  how our partner network is working to transform education, and
                  explore the benefits and opportunities of joining the XLP
                  ecosystem.
                </p>
              </div>
              <img
                src="assets-webp/misc/diverse_handshake.webp"
                alt="Partnership Handshake"
                className="img-fluid rounded-4 shadow-sm object-fit-cover"
              />
            </div>

            {/* Column 2 */}
            <div className="col-lg-4 d-flex flex-column gap-5 mt-5 pt-4">
              <img
                src="assets-webp/misc/meeting_top.webp"
                alt="Team working on laptops"
                className="img-fluid rounded-4 shadow-sm object-fit-cover"
              />
              <div className="step-content">
                <div className="step-circle shadow-sm">2</div>
                <h3 className="step-title">Invest in XLP</h3>
                <p className="step-text">
                  Support the expansion of innovative educational programmes
                  that empower students with creativity, critical thinking, and
                  real-world skills.
                </p>
              </div>
            </div>

            {/* Column 3 */}
            <div className="col-lg-4 d-flex flex-column gap-5">
              <div className="step-content">
                <div className="step-circle shadow-sm">3</div>
                <h3 className="step-title">Become an XLP Channel Partner</h3>
                <p className="step-text">
                  Launch XLP programmes through your network of schools and
                  institutions. Build your own channel for delivering XLP
                  services while creating a sustainable revenue stream.
                </p>
              </div>
              <img
                src="assets-webp/misc/diverse_teamup.webp"
                alt="Team hands stacked"
                className="img-fluid rounded-4 shadow-sm object-fit-cover"
              />
            </div>
          </div>

          {/* ==========================================
              MOBILE LAYOUT 
              ========================================== */}
          <div className="d-flex flex-column gap-5 d-lg-none mt-4">
            {/* Step 1 Group */}
            <div className="mobile-step-card">
              <div className="step-circle shadow-sm">1</div>
              <h3 className="step-title">Discover the Power of XLP Pulse</h3>
              <p className="step-text">
                Interested in <strong>XLP Pulse</strong>? Reach out to learn how
                our partner network is working to transform education, and
                explore the benefits and opportunities of joining the XLP
                ecosystem.
              </p>
              <img
                src="assets-webp/misc/diverse_handshake.webp"
                alt="Partnership Handshake"
                className="img-fluid rounded-4 shadow-sm mt-4 w-100 object-fit-cover"
              />
            </div>

            {/* Step 2 Group */}
            <div className="mobile-step-card">
              <div className="step-circle shadow-sm">2</div>
              <h3 className="step-title">Invest in XLP</h3>
              <p className="step-text">
                Support the expansion of innovative educational programmes that
                empower students with creativity, critical thinking, and
                real-world skills.
              </p>
              <img
                src="assets-webp/misc/meeting_top.webp"
                alt="Team working on laptops"
                className="img-fluid rounded-4 shadow-sm mt-4 w-100 object-fit-cover"
              />
            </div>

            {/* Step 3 Group */}
            <div className="mobile-step-card">
              <div className="step-circle shadow-sm">3</div>
              <h3 className="step-title">Become an XLP Channel Partner</h3>
              <p className="step-text">
                Launch XLP programmes through your network of schools and
                institutions. Build your own channel for delivering XLP services
                while creating a sustainable revenue stream.
              </p>
              <img
                src="assets-webp/misc/diverse_teamup.webp"
                alt="Team hands stacked"
                className="img-fluid rounded-4 shadow-sm mt-4 w-100 object-fit-cover"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ChannelHowItWorks;
